import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, ButtonGroup, Button, Typography } from '@mui/material';
import { setBookingMode } from 'store/filterSlice';
import { EBookingMode } from 'types';
import { bookingModeSelector } from 'helper/filter';

export const BookingModeSelector = () => {
  const dispatch = useDispatch();
  const bookingMode = bookingModeSelector();

  const handleModeToggle = (mode: EBookingMode) => {
    if (bookingMode !== mode) {
      dispatch(setBookingMode(mode));
    }
  };

  return (
    <Box sx={{ px: 2, py: 0.5 }}>
      <ButtonGroup variant="outlined" size="small" fullWidth>
        <Button
          onClick={() => handleModeToggle(EBookingMode.EPILO)}
          variant={bookingMode === EBookingMode.EPILO ? 'contained' : 'outlined'}
          sx={{
            fontSize: '0.75rem',
            padding: '4px 8px',
            fontWeight: bookingMode === EBookingMode.EPILO ? 500 : 400,
            opacity: bookingMode === EBookingMode.EPILO ? 1 : 0.7,
            ...(bookingMode !== EBookingMode.EPILO && {
              borderColor: 'rgba(172, 42, 110, 0.3)',
              color: 'rgba(172, 42, 110, 0.8)',
            }),
            '&:hover': {
              opacity: 1,
              backgroundColor: bookingMode === EBookingMode.EPILO ? undefined : 'rgba(172, 42, 110, 0.08)',
              ...(bookingMode !== EBookingMode.EPILO && {
                borderColor: 'rgba(172, 42, 110, 0.5)',
              }),
            },
          }}
        >
          seminargo
        </Button>
        <Button
          onClick={() => handleModeToggle(EBookingMode.SEM)}
          variant={bookingMode === EBookingMode.SEM ? 'contained' : 'outlined'}
          sx={{
            fontSize: '0.75rem',
            padding: '4px 8px',
            fontWeight: bookingMode === EBookingMode.SEM ? 500 : 400,
            opacity: bookingMode === EBookingMode.SEM ? 1 : 0.7,
            ...(bookingMode === EBookingMode.SEM && {
              backgroundColor: '#266670',
              '&:hover': {
                backgroundColor: '#1e5159',
              },
            }),
            ...(bookingMode !== EBookingMode.SEM && {
              borderColor: 'rgba(38, 102, 112, 0.3)',
              color: 'rgba(38, 102, 112, 0.8)',
              '&:hover': {
                opacity: 1,
                borderColor: 'rgba(38, 102, 112, 0.5)',
                backgroundColor: 'rgba(38, 102, 112, 0.04)',
              },
            }),
          }}
        >
          SEM
        </Button>
      </ButtonGroup>
    </Box>
  );
};
